import { createAsyncThunk } from "@reduxjs/toolkit";
import doFetch from "../../infrastructure/doFetch";
import { getQueryParams } from "../../helpers";
import { EMPTY_STRING } from "../../constants";
import { SPINNER_NAMES } from "../../components/organisms/Spinner";

const {
  UPDATE_USER,
  INVITE_USER,
  FETCH_USERS,
  UPDATE_USER_ROLE,
  CREATE_USER_ROLE,
  DELETE_USER_ROLES,
  DELETE_USER,
  FETCH_USER_SUBSCRIPTION,
  FETCH_INVITATIONS,
} = SPINNER_NAMES;

export const saveUser = createAsyncThunk(
  "save-user",
  async (user, args, { useCache, showSpinner } = {}) =>
    doFetch({
      url: "users",
      method: "POST",
      config: {
        body: JSON.stringify(user),
      },
      useCache,
      showSpinner,
      errorMessage: "Unable to save the user. Please try again later.",
      successMessage: "Successfully save user.",
      ...args,
    })
);

export const inviteUser = createAsyncThunk(
  "invite-user",
  async (user, args, { useCache, showSpinner } = {}) =>
    doFetch({
      url: "email?name=accept-invitation",
      method: "POST",
      config: {
        body: JSON.stringify(user),
      },
      useCache,
      showSpinner,
      spinner: `${INVITE_USER}${user.email}`,
      errorMessage: "Unable to invite the user. Please try again later.",
      successMessage: "User invited successfully.",
      ...args,
    })
);

export const fetchUsers = createAsyncThunk(
  "fetch-users",
  async (filters, args, { useCache, showSpinner } = {}) => {
    const queryParams = filters ? getQueryParams(filters) : EMPTY_STRING;
    return doFetch({
      url: `users?${queryParams}`,
      method: "GET",
      useCache,
      showSpinner,
      spinner: FETCH_USERS,
      errorMessage: "Unable to fetch users. Please try again later.",
      successMessage: "Successfully fetched users.",
      ...args,
    });
  }
);

export const deleteUser = createAsyncThunk(
  "delete-user",
  async (id, args, { useCache, showSpinner } = {}) =>
    doFetch({
      url: `users/${id}`,
      method: "DELETE",
      useCache,
      showSpinner,
      spinner: DELETE_USER,
      errorMessage: "Unable to delete the user. Please try again later.",
      successMessage: "Successfully deleted the user.",
      ...args,
    })
);

export const fetchUserRoles = createAsyncThunk(
  "fetch-user-roles",
  async ({ useCache, showSpinner } = {}, args) => {
    return doFetch({
      url: `user-roles`,
      method: "GET",
      useCache,
      showSpinner,
      errorMessage: "Unable to fetch user roles. Please try again later.",
      successMessage: "Successfully fetched user roles.",
      ...args,
    });
  }
);

// Need to Use PATCH when Invite user Functionality works.
export const updateUser = createAsyncThunk(
  "update-user",
  async ({ user, id, useCache, showSpinner } = {}, args) =>
    doFetch({
      url: `users/${id}`,
      method: "PATCH",
      config: {
        body: JSON.stringify(user),
      },
      useCache,
      showSpinner,
      spinner: UPDATE_USER,
      errorMessage: "Unable to update user. Please try again later.",
      successMessage: "Successfully updated user.",
      stubData: null,
      ...args,
    })
);

export const deleteUserRole = createAsyncThunk(
  "delete-user-role",
  async (id, args, { useCache, showSpinner } = {}) =>
    doFetch({
      url: `user-roles/${id}`,
      method: "DELETE",
      useCache,
      showSpinner,
      spinner: DELETE_USER_ROLES,
      errorMessage: "Unable to delete the user. Please try again later.",
      successMessage: "Successfully deleted the user.",
      ...args,
    })
);

export const createUserRole = createAsyncThunk(
  "create-user-role",
  async (userRoleDetails, args, { useCache, showSpinner } = {}) =>
    doFetch({
      url: `user-roles`,
      method: "POST",
      config: {
        body: JSON.stringify(userRoleDetails),
      },
      useCache,
      showSpinner,
      spinner: CREATE_USER_ROLE,
      errorMessage: "Unable to create user role. Please try again later.",
      successMessage: "Successfully created user role.",
      ...args,
    })
);

export const updateUserRole = createAsyncThunk(
  "update-user-role",
  async ({ userRoleDetails, id, useCache, showSpinner } = {}, args) =>
    doFetch({
      url: `user-roles/${id}`,
      method: "PATCH",
      config: {
        body: JSON.stringify(userRoleDetails),
      },
      useCache,
      showSpinner,
      spinner: UPDATE_USER_ROLE,
      errorMessage: "Unable to update user role. Please try again later.",
      successMessage: "Successfully updated user role.",
      stubData: null,
      ...args,
    })
);

export const fetchUserSubscription = createAsyncThunk(
  "fetch-user-subscription",
  async (id, args, { useCache, showSpinner } = {}) =>
    doFetch({
      url: `subscriptions/${id}`,
      method: "GET",
      useCache,
      showSpinner,
      spinner: FETCH_USER_SUBSCRIPTION,
      errorMessage:
        "Unable to fetch user's subscription. Please try again later.",
      successMessage: "Successfully fetched user's subscription.",
      ...args,
    })
);

export const updateUserSubscription = createAsyncThunk(
  "update-subscription",
  async ({ id, data, useCache, showSpinner } = {}, args) =>
    doFetch({
      url: `subscriptions/${id}`,
      method: "PATCH",
      config: {
        body: JSON.stringify(data),
      },
      useCache,
      showSpinner,
      errorMessage:
        "Unable to update user's subscription. Please try again later.",
      successMessage: "Successfully updated user's subscription.",
      ...args,
    })
);

export const fetchInvitations = createAsyncThunk(
  "fetch-Invitations",
  async (filters, args, { useCache,showSpinner } = {}) => {
    const queryParams = filters ? getQueryParams(filters) : EMPTY_STRING;
    return doFetch({
      url: `invitations?${queryParams}`,
      method: "GET",
      useCache,
      showSpinner,
      spinner: FETCH_INVITATIONS,
      errorMessage: "Unable to fetch invitations. Please try again later.",
      successMessage: "Successfully fetched invitations.",
      ...args,
    });
  }
);

export const updateInvitations = createAsyncThunk(
  "update-invitations",
  async ({ id, user, useCache } = {}, args) =>
    doFetch({
      url: `invitations/${id}`,
      method: "PATCH",
      config: {
        body: JSON.stringify(user),
      },
      useCache,
      errorMessage: "Unable to update the user. Please try again later.",
      successMessage: "Successfully updated the user.",
      ...args,
    })
);
